import React from 'react';
import { Link } from 'react-router-dom';
import { getDefaultName, mediaSrc } from '../../../utils';
import CountryName from '../../../components/CountryName';
import TalentName from '../../../components/TalentName';
import TranslateController from '../../../../controller/TranslateController';

const DEFAULT_IMAGE = '/assets/images/default.png';

export default function CourseCardsWidget({ courses, showDelete, loading, onDelete }) {
    const list = courses || [];

    const { _t } = TranslateController();

    return (
        <div className="talent-cards-grid course-cards-grid">
            {list.map((item, i) => {
                const historyId =
                    item.course_history && item.course_history.length > 0
                        ? item.course_history[0].id
                        : null;

                return (
                    <div
                        key={item.id}
                        className="talent-card-col"
                        style={{ animationDelay: `${Math.min(i * 42, 480)}ms` }}
                    >
                        <div className="talent-card course-card-item">
                            <a
                                href={`/cms/course/${item.id}`}
                                className="course-card-edit-btn"
                                title="Edit"
                            >
                                <i className="fa fa-edit"></i>
                            </a>
                            {showDelete && (
                                <button
                                    type="button"
                                    className="btn btn-danger btn-xs course-card-delete-btn"
                                    onClick={(e) => {
                                        if (window.confirm('Are you sure you wish to delete this item?')) {
                                            onDelete(item.id, e);
                                        }
                                    }}
                                >
                                    <i className="fa fa-trash"></i>
                                </button>
                            )}
                            <a href={`/cms/coursedetails/${item.id}`} className="course-card-media">
                                <img
                                    className="talent-card-img"
                                    src={mediaSrc(item.image, DEFAULT_IMAGE)}
                                    alt={getDefaultName(item.names)}
                                />
                            </a>
                            <a href={`/cms/coursedetails/${item.id}`} className="course-card-title-link">
                                {loading === item.id ? 'Loading...' : getDefaultName(item.names)}
                            </a>
                            <div className="course-card-sub">
                                {item.talents && item.talents.length > 0 ? (
                                    item.talents.map((tal, ti) => (
                                        <span key={typeof tal === 'object' ? tal.id : tal}>
                                            {ti > 0 ? ', ' : ''}
                                            {typeof tal === 'object' && tal.names ? (
                                                getDefaultName(tal.names)
                                            ) : (
                                                <TalentName id={typeof tal === 'object' ? tal.id : tal} />
                                            )}
                                        </span>
                                    ))
                                ) : item.talent ? (
                                    typeof item.talent === 'object' && item.talent.names ? (
                                        getDefaultName(item.talent.names)
                                    ) : (
                                        <TalentName
                                            id={typeof item.talent === 'object' ? item.talent.id : item.talent}
                                        />
                                    )
                                ) : (
                                    '—'
                                )}
                                <span className="course-card-sub-sep">·</span>
                                <span className={item.status ? 'course-card-status-open' : 'course-card-status-closed'}>
                                    {item.status ? 'Open' : 'Closed'}
                                </span>
                                {item.staff_preview ? (
                                    <>
                                        <span className="course-card-sub-sep">·</span>
                                        <span className="course-card-status-preview">Staff preview</span>
                                    </>
                                ) : null}
                            </div>
                            <div className="course-card-dates">
                                <span title="Start">
                                    <i className="fa fa-hourglass-1"></i> {item.startdate}
                                </span>
                                <span title="End">
                                    <i className="fa fa-hourglass-3"></i> {item.enddate}
                                </span>
                            </div>
                            <div className="course-card-pills">
                                <div className="course-card-pills-row">
                                    <Link
                                        title="View contest history, top 15 and more"
                                        className="talent-card-count course-card-pill"
                                        to={historyId ? `/cms/coursehistory/${historyId}` : '/cms/coursehistories'}
                                    >
                                        <i className="fa fa-history" aria-hidden />
                                        {_t('history')}
                                    </Link>
                                    <Link
                                        title="Contest participants"
                                        className="talent-card-count course-card-pill"
                                        to={`/cms/coursedetails/${item.id}`}
                                    >
                                        <i className="fa fa-users" aria-hidden />
                                        {(item.number_of_participants ?? 0).toLocaleString()}
                                    </Link>
                                </div>
                                <div className="course-card-pills-row">
                                    <Link
                                        title="Contest documents"
                                        className="talent-card-count course-card-pill"
                                        to={`/cms/coursedocuments/${item.id}`}
                                    >
                                        <i className="fa fa-file" aria-hidden />
                                    </Link>
                                    <Link
                                        title="Ratings for this contest"
                                        className="talent-card-count course-card-pill"
                                        to={`/cms/ratings/${item.id}`}
                                    >
                                        <i className="fa fa-star" aria-hidden />
                                    </Link>
                                </div>
                            </div>
                            <div className="course-card-country">
                                <CountryName id={item.country} />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
